import _ from "lodash"
import {
  AirportSeasonConfiguration,
  AirportSeasonConfigurations
} from "../api/AirportSeasonConfiguration"
import { Flight } from "../api/Flight"
import { Transaction, Transactions } from "../api/Transaction"
import { FieldName } from "./text"

export enum ActionCode {
  D = "D",
  C = "C",
  R = "R",
  N = "N"
}

export enum FlightMode {
  Turnaround = "T",
  Arrival = "A",
  Departure = "D"
}

export enum EditMode {
  ADD = "add",
  EDIT = "edit",
  RESPONSE = "response",
  VIEW = "view",
  AVAILABILITY = "availability"
}

export enum StatusCode {
  None = 0,
  Cleared = 1,
  Offered = 2,
  Refused = 3
}

export enum ActionType {
  CHANGE = "CHANGE",
  SHLCHANGENOOFFER = "SHLCHANGENOOFFER",
  SHLCHANGECONTINUATION = "SHLCHANGECONTINUATION",
  DELETE = "DELETE",
  SEARCH = "SEARCH",
  CLEARREQ = "CLEARREQ",
  MERGE = "MERGE",
  SWAP = "SWAP",
  ARRDEPSWAP = "ARRDEPSWAP",
  SWAPLINK = "SWAPLINK",
  SWAPAC = "SWAPAC",
  SWAPPERIOD = "SWAPPERIOD",
  LINK = "LINK",
  DELINK = "DELINK",
  SHLHISTORICS = "SHLHISTORICS",
  ACCEPT = "ACCEPT",
  PEND = "PEND",
  DECLINE = "DECLINE",
  SWAPARRTODEP = "SWAPARRTODEP",
  SWAPDEPTOARR = "SWAPDEPTOARR"
}

export enum PageGroup {
  GABA = "gaba",
  SERIES = "series",
  SINGLEDATE = "singleDate",
  SHL = "shl",
  OFFERS = "offers",
  DOWNLOAD = "download",
  HANDLING = "handling"
}

export enum GCRMode {
  FLT = "FLT",
  REG = "REG"
}

export enum FieldCategory {
  Airport = "Airport",
  Flight = "Flight",
  Period = "Period",
  Time = "Time",
  Aircraft = "Aircraft",
  Routing = "Routing",
  SearchTime = "Search Time",
  Handling = "Handling"
}

export interface IFieldOrderConfig {
  type: FieldName
  categoryOrder: number
  SSIMOrder: number
  category?: FieldCategory
  gabaOrder?: number
  gabaCategory?: FieldCategory
}

export const categoryOrder: FieldCategory[] = [
  FieldCategory.Airport,
  FieldCategory.Flight,
  FieldCategory.Period,
  FieldCategory.Time,
  FieldCategory.Aircraft,
  FieldCategory.Routing,
  FieldCategory.SearchTime,
  FieldCategory.Handling
]

export const fieldOrder: IFieldOrderConfig[] = [
  {
    type: FieldName.airport,
    category: FieldCategory.Airport,
    categoryOrder: 1,
    SSIMOrder: 1
  },
  {
    type: FieldName.responseCode,
    categoryOrder: 2,
    SSIMOrder: 2
  },
  {
    type: FieldName.requestCode,
    category: FieldCategory.Flight,
    categoryOrder: 3,
    SSIMOrder: 3
  },
  {
    type: FieldName.operatorArr,
    category: FieldCategory.Flight,
    categoryOrder: 4,
    SSIMOrder: 4
  },
  {
    type: FieldName.operatorDep,
    category: FieldCategory.Flight,
    categoryOrder: 5,
    SSIMOrder: 5
  },
  {
    type: FieldName.serviceNoArr,
    category: FieldCategory.Flight,
    categoryOrder: 6,
    SSIMOrder: 6
  },
  {
    type: FieldName.serviceNoDep,
    category: FieldCategory.Flight,
    categoryOrder: 7,
    SSIMOrder: 7
  },
  {
    type: FieldName.flightNoArr,
    categoryOrder: 8,
    SSIMOrder: 8
  },
  {
    type: FieldName.flightNoDep,
    categoryOrder: 9,
    SSIMOrder: 9
  },
  {
    type: FieldName.serviceTypes,
    categoryOrder: 10,
    SSIMOrder: 26
  },
  {
    type: FieldName.serviceTypeArr,
    category: FieldCategory.Flight,
    categoryOrder: 11,
    SSIMOrder: 27
  },
  {
    type: FieldName.serviceTypeDep,
    category: FieldCategory.Flight,
    categoryOrder: 12,
    SSIMOrder: 28
  },
  {
    type: FieldName.period,
    categoryOrder: 13,
    SSIMOrder: 10
  },
  {
    type: FieldName.startDate,
    category: FieldCategory.Period,
    categoryOrder: 14,
    SSIMOrder: 11
  },
  {
    type: FieldName.endDate,
    category: FieldCategory.Period,
    categoryOrder: 15,
    SSIMOrder: 12
  },
  {
    type: FieldName.reqDate,
    category: FieldCategory.Period,
    categoryOrder: 16,
    SSIMOrder: 13
  },
  {
    type: FieldName.doop,
    category: FieldCategory.Period,
    categoryOrder: 16,
    SSIMOrder: 13
  },
  {
    type: FieldName.woop,
    category: FieldCategory.Period,
    categoryOrder: 17,
    SSIMOrder: 29
  },
  {
    type: FieldName.clearedTimes,
    categoryOrder: 18,
    SSIMOrder: 19
  },
  {
    type: FieldName.clearedTimeArr,
    category: FieldCategory.Time,
    categoryOrder: 19,
    SSIMOrder: 20
  },
  {
    type: FieldName.clearedTimeDep,
    category: FieldCategory.Time,
    categoryOrder: 20,
    SSIMOrder: 21
  },
  {
    type: FieldName.requiredTimes,
    categoryOrder: 21,
    SSIMOrder: 30
  },
  {
    type: FieldName.requiredTimeArr,
    category: FieldCategory.Time,
    categoryOrder: 22,
    SSIMOrder: 31
  },
  {
    type: FieldName.requiredTimeDep,
    category: FieldCategory.Time,
    categoryOrder: 23,
    SSIMOrder: 32
  },
  {
    type: FieldName.reasonCodes,
    categoryOrder: 24,
    SSIMOrder: 33
  },
  {
    type: FieldName.reasonCodeArr,
    category: FieldCategory.Time,
    categoryOrder: 25,
    SSIMOrder: 34
  },
  {
    type: FieldName.reasonCodeDep,
    category: FieldCategory.Time,
    categoryOrder: 26,
    SSIMOrder: 35
  },
  {
    type: FieldName.turnaroundDays,
    category: FieldCategory.Time,
    categoryOrder: 27,
    SSIMOrder: 22
  },
  {
    type: FieldName.minGroundTime,
    category: FieldCategory.Time,
    categoryOrder: 28,
    SSIMOrder: 40
  },
  {
    type: FieldName.aircraftType,
    category: FieldCategory.Aircraft,
    categoryOrder: 29,
    SSIMOrder: 15
  },
  {
    type: FieldName.numSeats,
    category: FieldCategory.Aircraft,
    categoryOrder: 30,
    SSIMOrder: 14
  },
  {
    type: FieldName.vfr,
    category: FieldCategory.Aircraft,
    categoryOrder: 30,
    SSIMOrder: 51
  },
  {
    type: FieldName.towbar,
    category: FieldCategory.Aircraft,
    categoryOrder: 30,
    SSIMOrder: 51
  },
  {
    type: FieldName.noiseCertificate,
    category: FieldCategory.Aircraft,
    categoryOrder: 30,
    SSIMOrder: 51
  },
  {
    type: FieldName.aircraftRegistration,
    category: FieldCategory.Aircraft,
    categoryOrder: 31,
    SSIMOrder: 39,
    gabaOrder: 2,
    gabaCategory: FieldCategory.Flight
  },
  {
    type: FieldName.routeArr,
    categoryOrder: 32,
    SSIMOrder: 16
  },
  {
    type: FieldName.routeDep,
    categoryOrder: 33,
    SSIMOrder: 23
  },
  {
    type: FieldName.origDest,
    category: FieldCategory.Routing,
    categoryOrder: 34,
    SSIMOrder: -1
  },
  {
    type: FieldName.lastNext,
    category: FieldCategory.Routing,
    categoryOrder: 36,
    SSIMOrder: -1
  },
  {
    type: FieldName.originStation,
    category: FieldCategory.Routing,
    categoryOrder: -1,
    SSIMOrder: 17
  },
  {
    type: FieldName.destinationStation,
    category: FieldCategory.Routing,
    categoryOrder: -1,
    SSIMOrder: 25
  },
  {
    type: FieldName.lastStation,
    category: FieldCategory.Routing,
    categoryOrder: -1,
    SSIMOrder: 18
  },
  {
    type: FieldName.nextStation,
    category: FieldCategory.Routing,
    categoryOrder: -1,
    SSIMOrder: 24
  },
  {
    type: FieldName.offerTimeArr,
    category: FieldCategory.SearchTime,
    categoryOrder: 38,
    SSIMOrder: 41
  },
  {
    type: FieldName.offerTimeDep,
    category: FieldCategory.SearchTime,
    categoryOrder: 39,
    SSIMOrder: 42
  },
  {
    type: FieldName.terminals,
    categoryOrder: 40,
    SSIMOrder: 36
  },
  {
    type: FieldName.terminalArr,
    category: FieldCategory.Aircraft,
    categoryOrder: 32,
    SSIMOrder: 32
  },
  {
    type: FieldName.terminalDep,
    category: FieldCategory.Aircraft,
    categoryOrder: 32,
    SSIMOrder: 32
  },
  {
    type: FieldName.slotId,
    categoryOrder: 43,
    SSIMOrder: 43
  },
  {
    type: FieldName.slotIdArr,
    categoryOrder: 44,
    SSIMOrder: 44
  },
  {
    type: FieldName.slotIdDep,
    categoryOrder: 45,
    SSIMOrder: 45
  },
  {
    type: FieldName.noOfOperations,
    categoryOrder: 46,
    SSIMOrder: 46
  },
  {
    type: FieldName.handler,
    category: FieldCategory.Handling,
    categoryOrder: 50,
    SSIMOrder: 50
  },
  {
    type: FieldName.mtow,
    category: FieldCategory.Aircraft,
    categoryOrder: 30,
    SSIMOrder: 51
  },
  {
    type: FieldName.gabaLounge,
    category: FieldCategory.Handling,
    categoryOrder: 53,
    SSIMOrder: 53
  },
  {
    type: FieldName.refuelling,
    category: FieldCategory.Handling,
    categoryOrder: 54,
    SSIMOrder: 54
  },
  {
    type: FieldName.operatorText,
    category: FieldCategory.Handling,
    categoryOrder: 52,
    SSIMOrder: 52
  },
  {
    type: FieldName.parkingLocation,
    category: FieldCategory.Handling,
    categoryOrder: 51,
    SSIMOrder: 40
  }
]

const depFields = [
  FieldName.operatorDep,
  FieldName.serviceNoDep,
  FieldName.nextStation,
  FieldName.clearedTimeDep,
  FieldName.destinationStation,
  FieldName.serviceTypeDep,
  FieldName.offerTimeDepFrom,
  FieldName.offerTimeDepTo,
  FieldName.requiredTimeDep,
  FieldName.requiredDateDep
]

let includeFields = [
  FieldName.operatorArr,
  FieldName.operatorDep,
  FieldName.serviceNoArr,
  FieldName.serviceNoDep,
  FieldName.serviceTypeArr,
  FieldName.serviceTypeDep,
  FieldName.startDate,
  FieldName.endDate,
  FieldName.doop,
  FieldName.woop,
  FieldName.clearedTimeArr,
  FieldName.clearedTimeDep,
  FieldName.aircraftType,
  FieldName.numSeats,
  FieldName.aircraftRegistration,
  FieldName.originStation,
  FieldName.turnaroundDays,
  FieldName.minGroundTime,
  FieldName.lastStation,
  FieldName.nextStation,
  FieldName.destinationStation,
  FieldName.offerTimeArrFrom,
  FieldName.offerTimeArrTo,
  FieldName.offerTimeDepFrom,
  FieldName.offerTimeDepTo,
  FieldName.requiredTimeArr,
  FieldName.requiredTimeDep,
  FieldName.requiredDateArr,
  FieldName.requiredDateDep,
  FieldName.vfr,
  FieldName.towbar,
  FieldName.handler,
  FieldName.mtow,
  FieldName.operatorText,
  FieldName.gabaLounge,
  FieldName.refuelling,
  FieldName.terminalArr,
  FieldName.terminalDep
]

const arrFields = [
  FieldName.operatorArr,
  FieldName.serviceNoArr,
  FieldName.originStation,
  FieldName.lastStation,
  FieldName.clearedTimeArr,
  FieldName.serviceTypeArr,
  FieldName.offerTimeArrFrom,
  FieldName.offerTimeArrTo,
  FieldName.requiredTimeArr,
  FieldName.requiredDateArr
]

export function handleGetFlightChanges(
  transaction: Transaction,
  initialTransaction: Transaction,
  actionType: ActionType
) {
  const flightChanges = []
  const transactionClone = _.cloneDeep(transaction)
  const initialTransactionClone = _.cloneDeep(initialTransaction)
  transactionClone.flights.forEach((flight, idx) => {
    const fieldsWithChanges = handleGetFieldswChanges(
      flight,
      idx,
      initialTransactionClone,
      actionType
    )
    flightChanges.push(fieldsWithChanges)
  })
  return flightChanges
}

export function handleGetFieldswChanges(
  flight: Flight,
  flightIdx: number,
  initialTransaction: Transaction,
  actionType: ActionType
): string[] {
  const fieldsWithChanges: string[] = []
  const isLink = actionType === ActionType.LINK
  const isMerge = actionType === ActionType.MERGE
  let fields = _.cloneDeep(includeFields)

  const initialFlight = initialTransaction?.flights[flightIdx]
  let cFlight =
    flight.requestCode === ActionCode.R
      ? initialTransaction?.flights.find(
          (f) =>
            f.requestCode === ActionCode.C &&
            (isLink
              ? f.flightMode === FlightMode.Arrival
              : f.flightId === flight.flightId)
        )
      : null

  if (isLink && cFlight) {
    const cFlightDep = initialTransaction?.flights.find(
      (t) =>
        t.requestCode === ActionCode.C && t.flightMode === FlightMode.Departure
    )
    depFields.forEach((fieldName) => {
      cFlight[fieldName] = cFlightDep[fieldName]
    })
  }

  if (
    flight.flightMode === FlightMode.Arrival ||
    flight.flightMode === FlightMode.Departure
  ) {
    _.pullAll(
      fields,
      flight.flightMode === FlightMode.Arrival ? depFields : arrFields
    )
  }

  fields.forEach((fieldName) => {
    const flightVal = flight[fieldName]
    if (flightVal !== "") {
      const fieldHasInitDiff = !_.isEqual(
        flightVal,
        initialFlight ? initialFlight[fieldName] : flightVal
      )

      if (fieldHasInitDiff) {
        fieldsWithChanges.push(fieldName)
      } else if (
        isMerge &&
        flight.requestCode === ActionCode.R &&
        initialTransaction
      ) {
        const rFlight = initialTransaction.flights.find(
          (f) => f.requestCode === ActionCode.R
        )
        const fieldHasChanges = !_.every(initialTransaction.flights, [
          fieldName,
          rFlight[fieldName]
        ])
        if (fieldHasChanges) {
          fieldsWithChanges.push(fieldName)
        }
      } else if (cFlight && !isMerge) {
        const fieldIsDiffFromCFlight = !_.isEqual(flightVal, cFlight[fieldName])
        if (fieldIsDiffFromCFlight) {
          fieldsWithChanges.push(fieldName)
        }
      }
    }
  })

  return fieldsWithChanges
}

export function handleHasFlightsWithTerminal(
  airportSeasons: AirportSeasonConfigurations,
  transactions: Transactions
): boolean {
  if (transactions) {
    const transactionWithTerminalFlights = transactions.find((t) => {
      const flightWithTerminalAirport = t.flights.find((flight) => {
        const airportSeason = airportSeasons.find(
          (as) => as.airport === flight.airport
        )
        return airportSeason?.supportsTerminalRequest ? true : false
      })

      return flightWithTerminalAirport ? true : false
    })
    return transactionWithTerminalFlights ? true : false
  } else {
    return null
  }
}

export function handleHasFlightsWithParkingLoc(
  airportSeasons: AirportSeasonConfigurations,
  transactions: Transactions
): boolean {
  if (transactions) {
    const transactionWithParkingLocFlights = transactions.find((t) => {
      const flightWithParkingLocAirport = t.flights.find((flight) => {
        const airportSeason = airportSeasons.find(
          (as) => as.airport === flight.airport
        )
        return airportSeason?.parkingLocations.length > 0
      })

      return !!flightWithParkingLocAirport
    })
    return !!transactionWithParkingLocFlights
  } else {
    return null
  }
}

const flightHasAcRegServiceType = (
  serviceType: string,
  airportSeason: AirportSeasonConfiguration
) =>
  serviceType !== "" &&
  airportSeason?.showACRegForServiceTypes?.includes(serviceType)

export function handleHasFlightsWithServiceTypeAcReg(
  airportSeasons: AirportSeasonConfigurations,
  transactions: Transactions
): boolean {
  if (transactions) {
    const transactionWithServiceTypeAcRegFlights = transactions.find((t) => {
      const flightWithServiceTypeAcReg = t.flights.find((flight) => {
        const airportSeason = airportSeasons.find(
          (as) => as.airport === flight.airport
        )

        if (flight.flightMode === FlightMode.Turnaround) {
          return (
            flightHasAcRegServiceType(flight.serviceTypeArr, airportSeason) ||
            flightHasAcRegServiceType(flight.serviceTypeDep, airportSeason)
          )
        }

        return flight.flightMode === FlightMode.Arrival
          ? flightHasAcRegServiceType(flight.serviceTypeArr, airportSeason)
          : flightHasAcRegServiceType(flight.serviceTypeDep, airportSeason)
      })

      return !!flightWithServiceTypeAcReg
    })

    return !!transactionWithServiceTypeAcRegFlights
  } else {
    return null
  }
}
